import { gql } from 'apollo-boost';
import { fetchGraphQL } from 'core/services/graphQLservice'

// companyRep
// totalMovesScheduled
export async function getAmounts(CID: string) {

  var params = `query{
    getEstFlowTotalAmountsAndDetails(customerID:"${CID}")
  {
    type
    month
    amount
  }
}`

// var response = await fetchGraphQL('POST', params);
// debugger;
//   return response.data.getEstFlowTotalAmountsAndDetails;

return fetchGraphQL('POST', params);
}